import React, { forwardRef } from 'react';
import TextArea, { TextAreaProps } from './TextArea';
import Input, { InputProps } from './Input';

const InputOrTextArea = forwardRef<HTMLInputElement | HTMLTextAreaElement, InputOrTextAreaProps>(
    (props, ref) => {
        if (props.type === 'textarea') {
            const { type: _, ...rest } = props;
            return <TextArea ref={ref as React.ForwardedRef<HTMLTextAreaElement>} {...rest} />;
        }

        return <Input ref={ref as React.ForwardedRef<HTMLInputElement>} {...props} />;
    }
);

InputOrTextArea.displayName = 'InputOrTextArea';

export type InputOrTextAreaProps = InputProps | (TextAreaProps & { type: 'textarea' });

export default InputOrTextArea;
